import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'circle-category-carousel',
  templateUrl: './circle-category-carousel.component.html',
  styleUrls: ['./circle-category-carousel.component.scss'],
})
export class CircleCategoryCarouselComponent implements OnInit {
  @Input() categoryList: any[];
  @Input() selectedId: number;
  @Output() updateData = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}
  updateDataOfParent(id) {
    this.updateData.emit(id);
  }
}
